module.exports = __webpack_public_path__ + "img/mobradio-white.8008b344.png";